import React from 'react';
import Tooltip from '@amzn/meridian/tooltip';
import { SUCCESS_COLOR, WARNING_COLOR } from '@constants/values';
import Icon from '@amzn/meridian/icon';
import alertSuccessIconTokens from '@amzn/meridian-tokens/base/icon/alert-success-large';
import warning from '@amzn/meridian-tokens/base/icon/alert-warning-large';

export const BuyableCellRenderer = (prams: { value: boolean | null | undefined }) => {
  const { value } = prams;
  if (value === null || value === undefined) {
    return (
      <Tooltip position="end" title="Buyable information is not available" id="myTooltip">
        <Icon className={WARNING_COLOR} tokens={warning} />
      </Tooltip>
    );
  }
  if (value === false) {
    return (
      <Tooltip position="end" title="This product is not buyable" id="myTooltip">
        <Icon className={WARNING_COLOR} tokens={warning} />
      </Tooltip>
    );
  }
  return <Icon className={SUCCESS_COLOR} tokens={alertSuccessIconTokens} />;
};
export default BuyableCellRenderer;
